export default {
  // Endpoints
  loginEndpoint: '/dj-rest-auth/login/',
  registerEndpoint: '/dj-rest-auth/registration/',
  refreshEndpoint: '/dj-rest-auth/token/refresh/',
  logoutEndpoint: '/dj-rest-auth/logout/',
  checkEndpoint: '/dj-rest-auth/token/verify/',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
